// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
import expertReviewRoutes from './expertReview';
var MenuGroup = {
  render: function render(h) {
    return h('router-view');
  }
};
var teacherRouter = {
  path: '/teacher',
  component: Layout,
  redirect: '/teacher/list',
  name: 'Teacher',
  meta: {
    title: '名师',
    icon: 'peoples'
  },
  children: [{
    path: 'manage',
    component: MenuGroup,
    redirect: '/teacher/list',
    name: 'TeacherManage',
    meta: {
      title: '名师管理',
      icon: ''
    },
    children: [{
      path: '/teacher/list',
      component: function component() {
        return import('@/views/teacher/list/index');
      },
      name: 'TeacherList',
      meta: {
        title: '名师列表'
      }
    }, {
      path: '/teacher/approval',
      component: function component() {
        return import('@/views/teacher/approval/index');
      },
      name: 'TeacherApproval',
      meta: {
        title: '名师审批'
      }
    }, {
      path: '/teacher/consultation',
      component: function component() {
        return import('@/views/teacher/consultation/index');
      },
      name: 'TeacherConsultation',
      meta: {
        title: '免费咨询申请'
      }
    }, {
      path: '/teacher/category',
      component: function component() {
        return import('@/views/teacher/category/index');
      },
      name: 'TeacherCategory',
      meta: {
        title: '名师专业分类'
      }
    }, {
      path: '/teacher/type',
      component: function component() {
        return import('@/views/teacher/type/index');
      },
      name: 'TeacherType',
      meta: {
        title: '名师类型'
      }
    }]
  }, {
    path: '/masterConsult',
    component: MenuGroup,
    redirect: '/masterConsult/orders',
    name: 'TeacherMasterConsult',
    meta: {
      title: '名师咨询',
      icon: ''
    },
    children: [{
      path: '/masterConsult/services',
      component: function component() {
        return import('@/views/masterConsult/services');
      },
      name: 'TeacherPaidConsultServices',
      meta: {
        title: '服务管理'
      }
    }, {
      path: '/masterConsult/orders',
      component: function component() {
        return import('@/views/masterConsult/orders');
      },
      name: 'TeacherPaidConsultOrders',
      meta: {
        title: '咨询订单'
      }
    }, {
      path: '/masterConsult/reviews',
      component: function component() {
        return import('@/views/masterConsult/reviews');
      },
      name: 'TeacherPaidConsultReviews',
      meta: {
        title: '评价管理'
      }
    }, {
      path: '/masterConsult/settlements',
      component: function component() {
        return import('@/views/masterConsult/settlements');
      },
      name: 'TeacherPaidConsultSettlements',
      meta: {
        title: '收入对账'
      }
    }, {
      path: '/masterConsult/refunds',
      component: function component() {
        return import('@/views/masterConsult/refunds');
      },
      name: 'TeacherPaidConsultRefunds',
      meta: {
        title: '退款管理'
      }
    }, {
      path: '/masterConsult/disputes',
      component: function component() {
        return import('@/views/masterConsult/disputes');
      },
      name: 'TeacherPaidConsultDisputes',
      meta: {
        title: '争议处理'
      }
    }]
  }, {
    path: '/expertReview',
    component: MenuGroup,
    redirect: '/expertReview/services',
    name: 'TeacherExpertReview',
    meta: {
      title: '专家点评',
      icon: ''
    },
    children: expertReviewRoutes
  }]
};
export default teacherRouter;